import { useStaticQuery, graphql } from 'gatsby'

export const useResolutionPdfsList = () => {
  const { allSanityResolutionPdf } = useStaticQuery(
    graphql`
      query resolutionPdfsQuery {
        allSanityResolutionPdf {
          nodes {
            title
            pdfFile {
              asset {
                url
              }
            }
          }
        }
      }
    `
  )

  let result = {}

  if (allSanityResolutionPdf.nodes) {
    allSanityResolutionPdf.nodes.forEach(pdf => {
      result[pdf.title.trim()] = pdf.pdfFile.asset.url
    })
  }

  return result
}
